const ChartParameter = {
  DATE: 'date',
  END_DATE: 'endDate',
  KEY: 'key',
  PERIOD: 'period',
  TYPE: 'type',
};

export default ChartParameter;
